import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UnauthorizedLogicService {
  public unauthorizedScreenImage$ = new BehaviorSubject('/assets/image/auth_image.png');

  constructor(private readonly router: Router) {
    router.events.pipe(takeUntilDestroyed(),
      filter(event => event instanceof NavigationEnd)).subscribe(() => {
      this.getUnauthorizedScreenImage();
    });
  }

  private getUnauthorizedScreenImage(): void {
    switch (this.router.url) {
      case '/auth/support':
      case '/auth/support/confirmation':
        this.unauthorizedScreenImage$.next('/assets/image/support.png');
        break;
      case '/auth/reset-password':
      case '/auth/reset-password-code':
        this.unauthorizedScreenImage$.next('/assets/image/forgot_password.png');
        break;
      default:
        this.unauthorizedScreenImage$.next('/assets/image/auth_image.png');
    }
  }

}
